var _path, _circle, _circle2, _circle3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclein7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 488,
    height: 488,
    viewBox: "0 0 488 488",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M451.554 243.7C451.554 358.575 358.429 451.7 243.554 451.7C128.679 451.7 35.5542 358.575 35.5542 243.7C35.5542 128.825 128.679 35.7002 243.554 35.7002C358.429 35.7002 451.554 128.825 451.554 243.7ZM66.7542 243.7C66.7542 341.344 145.91 420.5 243.554 420.5C341.198 420.5 420.354 341.344 420.354 243.7C420.354 146.056 341.198 66.9002 243.554 66.9002C145.91 66.9002 66.7542 146.056 66.7542 243.7Z",
    fill: "#3B3D4B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 411.5,
    cy: 338.5,
    r: 15.5,
    fill: "#889BD3",
    fillOpacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 338.5,
    r: 15.5,
    fill: "#889BD3",
    fillOpacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.5,
    cy: 51.2002,
    r: 15.5,
    fill: "#889BD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M240.729 40.0722C240.701 38.1092 242.269 36.4918 244.233 36.497C246.196 36.5023 247.755 38.128 247.717 40.0908L247.266 62.9034C247.233 64.5888 245.84 65.9253 244.154 65.9208C242.468 65.9163 241.082 64.5724 241.058 62.8868L240.729 40.0722Z",
    fill: "#889BD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclein7);
export default __webpack_public_path__ + "static/media/circlein7.9aaa4f9ea895e7741192ac698cf8ba6a.svg";
export { ForwardRef as ReactComponent };